<ng-container>
    <!--    *ngIf="!requestError"-->
    <div class="newReqHead" id="top" fxFlex="100">
        <div class="viewRequestTitle">
            <div class="vrTitle">
                <title-back [addTitle]="viewDetails" [Title]="'Request No: '"
                            (back)="closeView()"></title-back>
                <span class="reqID" (click)="editRequest()">{{ requestService.selectedRequest?.request_number }}</span>
            </div>
            <div fxLayout="row wrap" class="chipset">
                <ng-container [ngSwitch]="requestService.selectedRequest?.request_type?.dev_name">
                    <!-- <ng-container *ngSwitchCase="'one_way'">
                    <mat-chip class="secondary-chip sleek-chip">One-way</mat-chip>
                    <mat-chip
                        class="secondary-chip sleek-chip">{{requestService?.selectedRequest?.requestor?.company?.legal_name ?? requestService?.selectedRequest?.requestor?.company?.name}}
                        {{requestService.selectedRequest?.transaction_type=='use' ? 'Uses' : 'Supplies'}}
                        &nbsp;
                        <span *ngFor="let item of requestService?.selectedRequest?.requirement; let last = last">
                            {{item?.quantity}}*{{item?.container_size_type?.display}} {{!last ? ',&nbsp;' : ''}}
                        </span>
                    </mat-chip>
                    </ng-container> -->
                    <ng-container *ngSwitchCase="'buy_sell'">
                        <mat-chip class="secondary-chip sleek-chip">Trade</mat-chip>
                        <mat-chip
                            class="secondary-chip sleek-chip">{{ requestService?.selectedRequest?.requestor?.company?.legal_name ?? requestService?.selectedRequest?.requestor?.company?.name }}
                            {{ requestService.selectedRequest?.transaction_type == 'use' ? 'Buys ' : 'Sells ' }} &nbsp;
                            <span
                                *ngFor="let item of requestService?.selectedRequest?.requirement">{{ item?.quantity }}
                                *{{ item?.container_size_type?.display }}
                            </span>
                        </mat-chip>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <mat-chip class="secondary-chip sleek-chip">
                            {{
                                requestService.selectedRequest?.request_type?.dev_name == 'lease' ? 'Lease' :
                                    requestService.selectedRequest?.request_type?.dev_name == 'empty_repo' ? 'Empty Repo' :
                                        'One-Way'
                            }}
                        </mat-chip>
                        <mat-chip class="secondary-chip sleek-chip">
                            {{ requestService?.selectedRequest?.requestor?.company?.legal_name ?? requestService?.selectedRequest?.requestor?.company?.name }}
                            {{ requestService.selectedRequest?.transaction_type == 'use' ? ' Uses ' : ' Supplies ' }}
                            &nbsp;
                            <ng-container  *ngIf="requestService.selectedRequest?.status.dev_name!='booking_confirmed'">
                                <span
                                    *ngFor="let item of requestService?.selectedRequest?.requirement | orderRequirements: 'container_size_type':'display':'asc'; let last = last">
                                    {{ item?.quantity }}
                                    *{{ item?.container_size_type?.display }}{{ !last ? ',&nbsp;' : '' }}
                                </span>
                            </ng-container>
                            <ng-container *ngIf="requestService.selectedRequest?.status.dev_name=='booking_confirmed'">
                                <span
                                    *ngFor="let item of bookingDetails?.requirements | orderRequirements: 'container_size_type':'display':'asc'; let last = last">
                                    {{ item?.quantity }}
                                    *{{ item?.container_size_type?.display }}{{ !last ? ',&nbsp;' : '' }}
                                </span>
                            </ng-container>
                        </mat-chip>
                    </ng-container>
                    <!-- <mat-chip class="secondary-chip sleek-chip" *ngSwitchCase="'lease'">Lease</mat-chip> -->
                </ng-container>
                <mat-chip class="sleek-chip" style="color:white"
                          [style.background-color]="requestService.selectedRequest?.status?.color">{{ requestService.selectedRequest?.status?.short_name }}
                </mat-chip>
                <mat-chip class="sleek-chip glider"
                          *ngIf="requestService.selectedRequest?.requestor?.company?.is_virgin">New Lead
                </mat-chip>
                <mat-chip *ngIf="requestService.selectedRequest?.is_booking_closed == true"><i class="flaticon-lock" matTooltip="booking locked"></i></mat-chip>
            </div>
            <!-- <div *ngIf="requestDetails?.arthakosh_id"> -->
            <!--     <logzy-go-to-external-app [goto_url]="externalAppUrl" [button_label]="'Invoices'"></logzy-go-to-external-app> -->
            <!-- </div> -->
        </div>
        <!-- <button mat-raised-button class="addBtn" (click)="cloneRequest()">Clone Request</button> -->
        <div class="viewActions" fxLayout.gt-xs="row" fxLayout="column">
            <app-mat-auto-search [isEditable]="true" [displayField]="'request_number'" class="m1em countriesInput"
                                 [name]="'request_number'" [itemTemplate]="requestItem" fxLayout="column"
                                 placeholder="Search other request" [masterDashboard]="false" [ngModel]="request"
                                 (ngModelChange)="onRequestSelection($event)" [idField]="null"
                                 [listUrl]="request_url+'?search=::search::'"></app-mat-auto-search>

        </div>
    </div>


    <!-- <div class="contentGrid" *ngIf="!showConfirmation">
    <logzy-content-loader id="card2" [set4]="loader"></logzy-content-loader>
    <div class="content form-group" id="card2" fxLayout="row wrap" *ngIf="!loader">


  </div>
  <logzy-table-loader class="content form-group" id=" card3" [set2]="loader" *ngIf="loader"
    style="margin-top: 2em;"></logzy-table-loader>
  <div class="content form-group" id="card3" fxLayout="row wrap" *ngIf="!loader">
    <div class="headContent d-flex justify-content-between" fxFlex="100">
        <span class="head">Details of Quotation
        </span>
        <i class="flaticon-download"></i>
    </div>
    <logzy-quotation-table [table_data]="dataSource" [displayedColumns]="displayedColumns"
        [displayedColumnData]="disColData" fxFlex="100"></logzy-quotation-table>

  </div>
  <logzy-content-loader id="card4" [set5]="loader"></logzy-content-loader>
  <div class="content form-group" id="card4" fxLayout="row wrap" *ngIf="!loader">
    <app-timeline-widget [class.position-abs]="!timeline" [model]="daily_activities"
        [action1]="timelineAction1"></app-timeline-widget>
  </div>
  </div> -->

    <!-- <ng-container *ngIf="!(review || reviewLease)"> -->
    <div class="contentFlex" [class.d-none]="review || reviewLease"
         [ngClass]=" viewFormContent=='quotations'|| viewFormContent=='negotiate'? 'contentFlexrow':'contentFlexcolumn' "
         *ngIf="!showConfirmation" fxFlex="100">

        <div class="contentAction">
            <ng-container *ngFor="let status of possibleButtonStatuses">
                <button mat-raised-button class="addBtn" [class.clickIt]="attention" [class.hidden]="!attention"
                        *ngIf="status.action_type==1000"
                        (click)="changeStatus(status,false,true,true)">{{ status.verb }}
                </button>
                <button mat-raised-button class="secondaryBtn" *ngIf="status.action_type==0"
                        [class.hidden]="!secondaryButton"
                        (click)="changeStatus(status,true,false,true)">{{ status.verb }}
                </button>
                <button mat-stroked-button *ngIf="status.action_type==-1000" [class.hidden]="!ternaryButton"
                        (click)="changeStatus(status,true,true,false)">{{ status.verb }}
                </button>
            </ng-container>
        </div>
        <div class="leaseInfoCoverContent " fxLayout="column"
             [ngClass]=" viewFormContent=='quotations'|| viewFormContent=='negotiate'? 'contentSet1':'contentSet2' ">
            <div *ngIf="requestService.selectedRequest?.request_type?.dev_name == 'lease'">
                <logzy-info-content *ngIf="viewFormContent=='quotations'|| viewFormContent=='negotiate'"
                                    [loader]=" loader" [requestDetails]="requestService?.selectedRequest"
                                    (editLR)="updateLeadRequest($event)" #test></logzy-info-content>
            </div>
            <div class="content form-group">
                <!-- [class.buttonSpace]="possibleButtonStatuses && viewFormContent=='quotations'|| viewFormContent=='negotiate'" -->

                <div class="iconWrapper">
                    <mat-radio-group class="iconList">

                        <!-- Quick Actions-->
                        <ng-container *ngIf="showQuickActionsForRejectedRequestForCustomer()">
                            <mat-radio-button class="icon" [class.active_menu]="selected_menu=='quick_actions'">
                                <i class="flaticon-enquiry-actions"></i>
                                <div class="mainmenu">
                                    <span class="menu-label">Quick Actions
                                        <i class="flaticon-down-chevron"></i></span>
                                    <mat-radio-group class="submenuList">
                                        <mat-radio-button class="icon"
                                                          *ngFor="let status of possibleQuickActionStatuses"
                                                          [class.active_sub_menu]="selected_menu_item==status.dev_name"
                                                          (click)="changeStatus(status,true,true,true)">
                                            <span class="menu-item-label">{{ status.verb }}</span>
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </mat-radio-button>
                        </ng-container>

                        <!-- Dynamic Sub Menus -->

                        <!-- Menus that has no submenus; has no click event registered to title -->
                        <ng-container *ngFor="let item of menuItems; index as i">
                            <mat-radio-button class="icon" *ngIf="item.items?.length == 0"
                                              (click)="menuClick(item.dev_name)"
                                              [class.active_menu]="selected_menu == item.dev_name">
                                <i [class]="item.icon"></i>
                                <span class="menu-label">{{ item.name }} </span>
                            </mat-radio-button>

                            <!-- Menus with SubMenus-->
                            <mat-radio-button class="icon" *ngIf="item.items?.length > 0"
                                              [class.active_menu]="selected_menu == item.dev_name">
                                <i [class]="item.icon"></i>
                                <div class="mainmenu">
                                    <span class="menu-label">{{ item.name }}
                                        <i class="flaticon-down-chevron"></i></span>
                                    <mat-radio-group class="submenuList">
                                        <mat-radio-button class="icon" *ngFor="let submenu of item.items"
                                                          [class.active_sub_menu]="selected_menu_item == submenu.dev_name"
                                                          (click)="itemClick(submenu.dev_name, item.dev_name)">
                                            <span class="menu-item-label">{{ submenu.name }}</span>
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </mat-radio-button>
                        </ng-container>
                        <ng-container *ngIf="requestService.selectedRequest?.status?.dev_name=='booking_confirmed'">
                            <mat-radio-button class="icon" (click)="gotoApp()">
                                <i class="flaticon-coin"></i>
                                <div class="mainmenu">
                                    <span class="menu-label">Invoicing</span>
                                </div>
                            </mat-radio-button>
                        </ng-container>
                    </mat-radio-group>
                    <div class="Breadcrumb" *ngIf="selected_menu=='operations'">
                        <ng-container *ngFor="let item of menuItems; index as i">
                            <ng-container *ngIf="item.items?.length > 0">
                                <div class="crumb" (click)="itemClick(submenu.dev_name, item.dev_name)"
                                     [class.currentCrumb]="selected_menu_item == submenu.dev_name"
                                     *ngFor="let submenu of item.items">
                                    {{ submenu.name }}
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
                <div class="formContent" [ngSwitch]="viewFormContent" fxLayout="row">
                    <ng-container *ngSwitchDefault>
                        <logzy-gear-loader></logzy-gear-loader>
                    </ng-container>
                    <ng-container *ngSwitchCase="'initial'">
                        <ng-container *ngFor="let quote of quoteList">
                            <logzy-request-initial (accept)="viewFormContent='accepted_by_internal_user'"
                                                   [commercials]="quote"
                                                   [requestType]="requestService.selectedRequest?.request_type?.dev_name"
                                                   (reject)="viewFormContent='reject_by_internal_user'"></logzy-request-initial>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'status_change'">
                        <ng-container [ngSwitch]="changeToStatusDevName">
                            <ng-container *ngSwitchCase="'accepted_by_internal_user'">
                                <logzy-request-accept-form [changeToStatus]="changeToStatusName" fxLayout="row wrap"
                                                           fxFlex="100" [showPreviousQuotes]="false" class="baseform"
                                                           (updateAction)="updateRequestPage()">
                                </logzy-request-accept-form>
                            </ng-container>
                            <ng-container *ngSwitchCase="'reject_by_internal_user'">
                                <logzy-request-reject-form [changeToStatus]="changeToStatusName" fxLayout="row wrap"
                                                           fxFlex="100" [show]="false" class="baseform"
                                                           (updateAction)="updateRequestPage()">
                                </logzy-request-reject-form>
                            </ng-container>
                            <ng-container *ngSwitchCase="'reject_by_internal_user_after_acceptance'">
                                <logzy-request-reject-form [changeToStatus]="changeToStatusName" fxLayout="row wrap"
                                                           fxFlex="100" [show]="false" class="baseform"
                                                           (updateAction)="updateRequestPage()">
                                </logzy-request-reject-form>
                            </ng-container>
                            <ng-container *ngSwitchCase="'rejected_by_internal_user_after_sending_quote'">
                                <logzy-request-reject-form [changeToStatus]="changeToStatusName" fxLayout="row wrap"
                                                           fxFlex="100" [show]="false" class="baseform"
                                                           (updateAction)="updateRequestPage()">
                                </logzy-request-reject-form>
                            </ng-container>
                            <ng-container *ngSwitchCase="'rejected_by_internal_user_after_booking_confirmed'">
                                <logzy-request-reject-form [changeToStatus]="changeToStatusName" fxLayout="row wrap"
                                                           fxFlex="100" [show]="false" class="baseform"
                                                           (updateAction)="updateRequestPage()">
                                </logzy-request-reject-form>
                            </ng-container>
                            <ng-container *ngSwitchCase="'transferred_internal'">
                                <logzy-request-transfer-form [changeToStatus]="changeToStatusName" fxLayout="row wrap"
                                                             fxFlex="100" class="baseform"
                                                             (updateAction)="updateRequestPage()">
                                </logzy-request-transfer-form>
                            </ng-container>
                            <ng-container *ngSwitchCase="'shared_by_internal'">
                                <logzy-request-transfer-form [changeToStatus]="changeToStatusName" fxLayout="row wrap"
                                                             fxFlex="100" class="baseform"
                                                             (updateAction)="updateRequestPage()">
                                </logzy-request-transfer-form>
                            </ng-container>
                            <ng-container *ngSwitchCase="'transferred_by_internal_user'">
                                <logzy-request-transfer-form [changeToStatus]="changeToStatusName" fxLayout="row wrap"
                                                             fxFlex="100" class="baseform"
                                                             (updateAction)="updateRequestPage()">
                                </logzy-request-transfer-form>
                            </ng-container>


                            <ng-container *ngSwitchDefault>
                                <logzy-request-status-change-form [changeToStatus]="changeToStatusCache"
                                                                  (updateAction)="updateRequestPage()"></logzy-request-status-change-form>
                            </ng-container>

                            <!-- ngSwitch does not evaluate || (OR condition) in ngSwitchCase,
                                so made copy instead, of same component which should be shown for multiple ngSwitchCase-->
                            <ng-container *ngSwitchCase="'accepted_by_internal_user_after_negotiation'">
                                <ng-container *ngFor="let quote of quoteList">
                                    <logzy-request-confirm-booking [commercials]="quote"
                                                                   [changeToStatus]="changeToStatusCache"
                                                                   [requestType]="requestService.selectedRequest?.request_type?.dev_name"
                                                                   (updateAction)="updateRequestPage()"
                                                                   (celebrate)="celebration($event)"></logzy-request-confirm-booking>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="'accepted_by_internal_user_after_sending_quote'">
                                <logzy-review-quotation
                                    *ngIf="requestService.selectedRequest?.request_type?.dev_name!='lease' &&
                                    requestService.selectedRequest?.request_type?.dev_name!='empty_repo'"
                                    [commercials]="reviewQuoteData" [reviewing]="false" [HeaderSet]="false"
                                    fxFlex="100"[bookingDetails]="bookingDetails"></logzy-review-quotation>
                                <logzy-lease-review-quotation
                                    *ngIf="requestService.selectedRequest?.request_type?.dev_name=='lease'"
                                    [commercials]="reviewQuoteData" [reviewing]="true"
                                    fxFlex="100" [bookingDetails]="bookingDetails"></logzy-lease-review-quotation>
                            </ng-container>

                        </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'key_insights'">
                        <logzy-key-insights fxLayout="row wrap" fxFlex="100"></logzy-key-insights>
                    </ng-container>
                    <!-- <ng-container *ngSwitchCase="'Cancel Request'">  $$only customer can cancel the request$$
                        <logzy-request-status-change-form fxLayout="row wrap" fxFlex="100" class="baseform"
                        (updateAction)="updateRequestPage()">
                        </logzy-request-status-change-form>
                    </ng-container> -->
                    <ng-container *ngSwitchCase="'request_altered_by_internal_user'">
                        <logzy-request-alter-form fxLayout="row wrap" fxFlex="100" class="baseform">
                        </logzy-request-alter-form>
                    </ng-container>

                    <ng-container *ngSwitchCase="'commercials'">
                        <logzy-review-quotation
                            *ngIf="requestService.selectedRequest?.request_type?.dev_name!='lease' &&
                                        requestService.selectedRequest?.request_type?.dev_name!='empty_repo'"
                            [reviewQuote]="true" [commercials]="reviewQuoteData" [reviewing]="false"
                            [HeaderSet]="false"
                            fxFlex="100" [bookingDetails]="bookingDetails"></logzy-review-quotation>
                        <logzy-lease-review-quotation
                            *ngIf="requestService.selectedRequest?.request_type?.dev_name=='lease'"
                            [commercials]="reviewQuoteData" [reviewing]="false" [HeaderSet]="false"
                            fxFlex="100" [bookingDetails]="bookingDetails"></logzy-lease-review-quotation>
                    </ng-container>

                    <ng-container *ngSwitchCase="'quotations'">
                        <ng-container *ngIf="requestService.selectedRequest?.request_type?.dev_name == 'lease'">
                            <logzy-lease-quote-table [negotiate]="negotiate" [refreshQuote]="refreshLeaseQuote"
                                                     (edit)="editQuote()" (updateRequest)="updateRequestPage()"
                                                     (review)="reviewLeaseQuote($event)"
                                                     (editPickup)="updatePickUp($event)"
                                                     (editDropoff)="updateDropoff($event)"
                                                     [requestDetails]="requestService?.selectedRequest"
                                                     [leaseRequestDetails]="requestDetails"
                                                     fxFlex="100"></logzy-lease-quote-table>
                        </ng-container>
                        <ng-container *ngIf="requestService.selectedRequest?.request_type?.dev_name == 'one_way'">
                            <logzy-oneway-quote-table [negotiate]="negotiate" [refreshQuote]="refreshOneWayQuote"
                                                      (edit)="editQuote()" (updateRequest)="updateRequestPage()"
                                                      [requestDetails]="requestDetails"
                                                      (review)="reviewQuote($event)"
                                                      fxFlex="100"></logzy-oneway-quote-table>
                        </ng-container>
                        <ng-container *ngIf="requestService.selectedRequest?.request_type?.dev_name == 'buy_sell'">
                            <logzy-trade-quote-table [negotiate]="negotiate" [refreshQuote]="refreshTradeQuote"
                                                     (edit)="editQuote()" (updateRequest)="updateRequestPage()"
                                                     [requestDetails]="requestDetails"
                                                     (review)="reviewQuote($event)"
                                                     fxFlex="100"></logzy-trade-quote-table>
                        </ng-container>
                        <ng-container *ngIf="requestService.selectedRequest?.request_type?.dev_name == 'empty_repo'">
                            <logzy-empty-repo-quote-table [negotiate]="negotiate" [refreshQuote]="refreshEmptyRepoQuote"
                                                          (edit)="editQuote()" (updateRequest)="updateRequestPage()"
                                                          (review)="reviewLeaseQuote($event)"
                                                          [requestDetails]="requestService?.selectedRequest"
                                                          [emptyRepoRequestDetails]="requestDetails"
                                                          (errorLog)="editRequest()"
                                                          fxFlex="100">
                            </logzy-empty-repo-quote-table>
                        </ng-container>
                        <!-- <logzy-request-timeline fxFlex="16" fxLayout="column"></logzy-request-timeline> -->
                    </ng-container>
                    <ng-container *ngSwitchCase="'negotiate'">
                        <ng-container *ngIf="requestService.selectedRequest?.request_type?.dev_name == 'lease'">
                            <logzy-lease-quote-table [negotiate]="negotiate" [refreshQuote]="refreshLeaseQuote"
                                                     (edit)="editQuote()" (updateRequest)="updateRequestPage()"
                                                     (review)="reviewLeaseQuote($event)"
                                                     (editPickup)="updatePickUp($event)"
                                                     (editDropoff)="updateDropoff($event)"
                                                     [requestDetails]="requestService?.selectedRequest"
                                                     fxFlex="100"></logzy-lease-quote-table>
                        </ng-container>
                        <ng-container *ngIf="requestService.selectedRequest?.request_type?.dev_name == 'one_way'">
                            <logzy-oneway-quote-table [negotiate]="negotiate" [refreshQuote]="refreshOneWayQuote"
                                                      (edit)="editQuote()" (updateRequest)="updateRequestPage()"
                                                      (review)="reviewQuote($event)"
                                                      fxFlex="100"></logzy-oneway-quote-table>
                        </ng-container>
                        <ng-container *ngIf="requestService.selectedRequest?.request_type?.dev_name == 'buy_sell'">
                            <logzy-trade-quote-table [negotiate]="negotiate" [refreshQuote]="refreshTradeQuote"
                                                     (edit)="editQuote()" (updateRequest)="updateRequestPage()"
                                                     (review)="reviewQuote($event)"
                                                     fxFlex="100"></logzy-trade-quote-table>
                        </ng-container>
                        <ng-container *ngIf="requestService.selectedRequest?.request_type?.dev_name == 'empty_repo'">
                            <logzy-empty-repo-quote-table [negotiate]="negotiate" [refreshQuote]="refreshEmptyRepoQuote"
                                                          (edit)="editQuote()" (updateRequest)="updateRequestPage()"
                                                          (review)="reviewLeaseQuote($event)"
                                                          [requestDetails]="requestService?.selectedRequest"
                                                          (errorLog)="editRequest()"
                                                          fxFlex="100">
                            </logzy-empty-repo-quote-table>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'release_order'">
                        <logzy-release-order (editRO)="editReleaseOrder($event)" (cancelRO)="cancelRequest($event)"
                                             fxFlex="100" (revalidateRO)="revalidateRequest($event)"
                                             [addRelease]="addRelease"
                                             (revalidateCRO)="revalidateCustRequest($event)"
                                             (openDepotForm)="openDepotForm($event)"
                                             (navigatePickUp)="changeViewFormContent($event)"
                                             (containerListRO)="openContainerList($event)"
                                             [RefreshReleaseOrder]="refreshTable"
                                             fxLayout="column" #test></logzy-release-order>
                    </ng-container>
                    <ng-container *ngSwitchCase="'return_reference'">
                        <logzy-return-reference (editROrder)="editReturnOrder($event)" [addRelease]="addReturn"
                                                (cancelRetO)="cancelRORequest($event)"
                                                (revalidateRetO)="revalidateRORequest($event)"
                                                (revalidateCRetO)="revalidateROCustRequest($event)"
                                                (openDepotForm)="openDepotForm($event)"
                                                (navigateDropoff)="changeViewFormContent($event)" fxLayout="column"
                                                fxFlex="100"></logzy-return-reference>
                    </ng-container>
                    <ng-container *ngSwitchCase="'pickup_return'">
                        <logzy-pickup-return fxLayout="column" fxFlex="100"
                                             (navigatePickUp)="changeViewFormContent($event,true)"></logzy-pickup-return>
                    </ng-container>
                    <ng-container *ngSwitchCase="'return'">
                        <!-- <logzy-return-container fxLayout="column" fxFlex="100"></logzy-return-container> -->
                        <logzy-return-containers [request_id]="request_id" fxFlex="100"
                                                 (navigatePickUp)="changeViewFormContent($event,true)"></logzy-return-containers>
                    </ng-container>
                    <ng-container *ngSwitchCase="'re_export'">
                        <logzy-reexport-containers [request_id]="request_id" fxFlex="100"
                                                   (navigatePickUp)="changeViewFormContent($event,true)"></logzy-reexport-containers>
                    </ng-container>
                    <ng-container *ngSwitchCase="'movement_details'">
                        <logzy-vessel-movement-details fxFlex="100"></logzy-vessel-movement-details>
                    </ng-container>
                    <ng-container *ngSwitchCase="'communication'">
                        <logzy-communications fxLayout="row wrap"
                                              [requestDetails]="requestDetails"></logzy-communications>
                    </ng-container>
                    <!-- <div class="content form-group" fxFlex="23"> -->
                    <ng-container *ngSwitchCase="'cold_leads'">
                        <logzy-cold-leads (reqContainers)="showContainers($event)"></logzy-cold-leads>
                    </ng-container>
                    <!-- </div> -->
                    <ng-container *ngSwitchCase="'documents'">
                        <mat-tab-group animationDuration="1500ms" class="w-100i">
                            <mat-tab label="Comments">
                                <div class="additionalDetails">
                                    <logzy-quote-remarks fxFlex="100"></logzy-quote-remarks>
                                </div>
                            </mat-tab>
                            <mat-tab label="Documents">
                                <logzy-request-documents fxFlex="100"></logzy-request-documents>
                            </mat-tab>
                        </mat-tab-group>
                    </ng-container>
                    <!--                    <ng-container *ngSwitchCase="'booking_charges'">-->
                    <!--                        <logzy-booking-charges [hideAddCharge]="true" style="display: contents"></logzy-booking-charges>-->
                    <!--                    </ng-container>-->
                </div>
            </div>
        </div>

        <div class="sideContent"
             [ngClass]=" viewFormContent=='quotations'|| viewFormContent=='negotiate'? 'sideContentSet1':'sideContentSet2' "
             [class.buttonSpace]="possibleButtonStatuses.length >= 1 ">
            <ng-container [ngSwitch]="viewFormContent">
                <div class="sideContentBox" fxLayout="row" *ngSwitchDefault>
                    <ng-container
                        *ngIf="requestService.selectedRequest?.status?.dev_name=='booking_confirmed' && reviewQuoteData!=null">
                        <ng-container *ngIf="type != 'use'">
                            <logzy-review-quotation
                                *ngIf="requestService.selectedRequest?.request_type?.dev_name!='lease' &&
                                        requestService.selectedRequest?.request_type?.dev_name!='empty_repo'"
                                [commercials]="reviewQuoteData" [reviewing]="false" [HeaderSet]="true"
                                fxFlex="100" [bookingDetails]="bookingDetails"></logzy-review-quotation>
                            <logzy-lease-review-quotation
                                *ngIf="requestService.selectedRequest?.request_type?.dev_name=='lease'"
                                [commercials]="reviewQuoteData" [reviewing]="false" [HeaderSet]="true"
                                fxFlex="100" [bookingDetails]="bookingDetails"></logzy-lease-review-quotation>
                        </ng-container>
                        <ng-container *ngIf="type == 'use'">
                            <logzy-oneway-trade-after-confirmation
                                *ngIf="requestService.selectedRequest?.request_type?.dev_name!='lease' &&
                                        requestService.selectedRequest?.request_type?.dev_name!='empty_repo'"
                                [commercials]="reviewQuoteData" [reviewing]="false" [HeaderSet]="true"
                                fxFlex="100" [bookingDetails]="bookingDetails"
                                (reqContainers)="showContainers($event)" (reopenLogs)="showReopenLogs($event)" (bookingViewLogs)="showLogs($event)" (addInvoiceParty)="invoiceParty($event)"></logzy-oneway-trade-after-confirmation>
                            <logzy-lease-after-confirmation
                                *ngIf="requestService.selectedRequest?.request_type?.dev_name=='lease'"
                                [commercials]="reviewQuoteData" [reviewing]="false" [HeaderSet]="true"
                                [bookingDetails]="bookingDetails" [bookingRequirements]="bookingDetails?.requirements"
                                fxFlex="100" (reqContainers)="showContainers($event)" (reopenLogs)="showReopenLogs($event)" (bookingViewLogs)="showLogs($event)" (addInvoiceParty)="invoiceParty($event)">
                            </logzy-lease-after-confirmation>
                        </ng-container>
                        <logzy-empty-repo-review-quotation
                            *ngIf="requestService.selectedRequest?.request_type?.dev_name=='empty_repo'"
                            [commercials]="reviewQuoteData" [reviewing]="true"
                            [bookingDetails]="bookingDetails"
                            [bookingRequirements]="bookingDetails?.requirements" fxFlex="100"
                            (reqContainers)="showContainers($event)">
                        </logzy-empty-repo-review-quotation>
                    </ng-container>

                </div>
                <div class="sideContentBox" fxLayout="column" *ngSwitchCase="'quotations'">
                    <!-- <logzy-timeline-detailed></logzy-timeline-detailed> -->
                    <logzy-communications [requestDetails]="requestDetails" [compact]="true" [chatBoxMax]="true"
                                          *ngIf="viewChat"></logzy-communications>
                    <!-- <logzy-timeline-detailed [direction]="false"></logzy-timeline-detailed> -->
                </div>
                <div class="sideContentBox" fxLayout="column" *ngSwitchCase="'negotiate'">
                    <logzy-communications [requestDetails]="requestDetails" [compact]="true"
                                          *ngIf="viewChat"></logzy-communications>

                </div>
            </ng-container>
        </div>

        <button class="edit" [class.d-none]="review || reviewLease" color="primary" mat-fab cdkDrag
                cdkDragBoundary=".contentFlex" (click)="chatViewToggle()" (mousedown)="ifDown()"
                (mousemove)="onMouseMove($event)" [class.clickIt]="newNotificationFlag && !viewChat"
                [matTooltip]="viewChat?'Hide chat':'Show chat'" matTooltipPosition="left">
            <i MatSuffix class="flaticon-chat"></i>
            <div class="notificationDot" *ngIf="newNotificationFlag && !viewChat"></div>
        </button>
    </div>

    <logzy-review-quotation *ngIf="review" [commercials]="reviewQuoteData" [reviewing]="true" [HeaderSet]="false"
                            (closeReview)="closeReview($event)" fxFlex="100" [bookingDetails]="bookingDetails"></logzy-review-quotation>
    <logzy-lease-review-quotation *ngIf="reviewLease" [reviewing]="true" [HeaderSet]="false"
                                  [commercials]="reviewQuoteData" (closeReview)="closeLeaseReview($event)"
                                  (backToQuote)="back()"
                                  fxFlex="100" [bookingDetails]="bookingDetails"></logzy-lease-review-quotation>


    <div class="confirmation" *ngIf="showConfirmation">
        <img src="assets/images/backgrounds/request-confirm.png" alt="">

        <span>Congratulations! Deal for request no: <b>ARCUO8343162</b> is confirmed. Team will be shortly communicating
            with you for DO.</span>
        <mat-chip color="primary" selected (click)="showConfirmation=false"><i class="flaticon-download"></i> Download
            Smart Contract
        </mat-chip>
    </div>

    <ng-template #requestItem let-item let-index>
        <div fxFlex="100" fxLayout="column" class="requestListShow">
            <span class="requestNumber">
                {{ item?.request_number }}
                <span> ({{ item.request_type.name }} | {{
                        item?.request_type?.dev_name == 'buy_sell' ?
                            item?.transaction_type == 'use' ? 'Buy' : 'Sell' : item?.transaction_type == 'use' ? 'Use' : 'Supply'
                    }}
                    {{ item?.requirement[0]?.quantity }}*{{ item?.requirement[0]?.container_size_type?.display }})
                    <ng-container *ngIf="item?.requirement.length>1">+ {{ item?.requirement.length - 1 }}
                        More</ng-container>
                </span>
            </span>
            <span class="companyName">
                {{ item?.company ?? '-' }}
            </span>
        </div>
    </ng-template>
</ng-container>
<!--<ng-container *ngIf="requestError">-->
<!--    <div>This request does not exist or you do not have permission to view this request..!!</div>-->
<!--</ng-container>-->
